import request from '../../libs/request';

export default {
  setDelivery: (siteId, id, sellerId, token, queryParams) =>
    request(`api/v1/${siteId}/carrinho/checkout/${id}/freight/${sellerId}`).put({ token, queryParams }),

  getThirdParty: (id, siteId) => {
    return request(`${siteId}/carrinho/${id}/autorizacao`, 'ocean').get();
  },

  setThirdParty: (siteId, cartId, sellerId, body) =>
    request(`${siteId}/carrinho/${cartId}/autorizacao/${sellerId}`, 'ocean').post({ body }),

  removeThirdParty: (cartId, thirdPartyId, token, siteId) => {
    return request(`${siteId}/carrinho/${cartId}/autorizacao/${thirdPartyId}`, 'ocean').delete({ token });
  },
};
